import cx from 'classnames'
import _ from 'lodash'

import DropdownToggle from './components/DropdownToggle/DropdownToggle'
import ToggleButton from './components/ToggleButton/ToggleButton'

import './ToggleButtonRow.scss'

const ToggleButtonRow = ({
    btns,
    onClick,
    disabled,
    ticketId,
    classNameShrink,
    className,
    selected,
    isShrinkable,
    withBorderRadius,
    dropdownOpen,
    setDropdownMenu,
}) => {
    if (_.isEmpty(btns)) return null

    if (isShrinkable) {
        const activeBtn = btns?.find((btn) => btn?.customer_categoryid === selected)

        return (
            <div className={cx('shrinkable-toggle-btn-row', classNameShrink)}>
                <DropdownToggle
                    labelId={activeBtn?.name}
                    open={dropdownOpen}
                    onClick={setDropdownMenu}
                    withBorderRadius
                    disabled={disabled}
                />
                <div className={cx('desktop toggle-btn-row', className, 'flex')}>
                    {btns?.map((btn) => (
                        <ToggleButton
                            key={`toggle-btn-group-btn-${btn?.customer_categoryid}`}
                            id={btn?.customer_categoryid}
                            active={selected === btn?.customer_categoryid}
                            disabled={disabled}
                            labelId={btn?.name}
                            iconAsLabel={btn?.iconAsLabel}
                            icon={btn?.icon}
                            onClick={() => onClick({ id: btn?.customer_categoryid, ticketId })}
                            withBorderRadius={withBorderRadius}
                        />
                    ))}
                </div>
            </div>
        )
    }

    return (
        <div className={cx('toggle-btn-row', className)}>
            {btns?.map((btn) => (
                <ToggleButton
                    key={`toggle-btn-group-btn-${btn?.customer_categoryid}`}
                    id={btn?.customer_categoryid}
                    active={selected === btn?.customer_categoryid}
                    disabled={disabled}
                    labelId={btn?.name ?? 'basic'}
                    iconAsLabel={btn?.iconAsLabel}
                    icon={btn?.icon}
                    onClick={() => onClick({ id: btn?.customer_categoryid, ticketId })}
                    withBorderRadius={withBorderRadius}
                />
            ))}
        </div>
    )
}

export default ToggleButtonRow
